module.exports = __webpack_public_path__ + "static/media/se02.b2fa266f.jpg";